import {ButtonProps} from './props';
import * as S from './style';

export const Button = (props: ButtonProps) => {
  return <S.Button>{props.label}</S.Button>;
};
